import { createSlice } from "@reduxjs/toolkit";
import {
  getMonthlyRevenueByPeriodBuilder,
  getMonthlyRevenuesBuilder,
} from "./builder";

const initialState = {
  monthlyRevenueByPeriod: {
    data: [],
    loading: false,
    error: null,
  },
  monthlyRevenue: {
    data: [],
    loading: false,
    error: null,
  },
};

export const revenueSlice = createSlice({
  name: "revenueInfo",
  initialState,
  reducers: {
    clearMonthlyRevenueError: (state) => {
      state.monthlyRevenueByPeriod.error = null;
    },
  },

  extraReducers: (builder) => {
    getMonthlyRevenueByPeriodBuilder(builder);
    getMonthlyRevenuesBuilder(builder);
    // Handle logout
    builder.addCase("auth/logout", (state) => {});
  },
});

export const { clearMonthlyRevenueError } = revenueSlice.actions;

// Selectors
export const selectMonthlyRevenueByPeriod = (state) =>
  state.revenueInfo.monthlyRevenueByPeriod;

export const selectMonthlyRevenues = (state) =>
  state.revenueInfo.monthlyRevenue;

export default revenueSlice.reducer;
